import React from 'react';
import styled from 'styled-components';

const Bar = styled.footer`
  background: rgba(0, 0, 0, 0.35);
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.2rem;
  text-align: center;
  padding: 11px 24px;

  a {
    color: rgba(255, 255, 255, 0.85);
    text-decoration: none;

    &:hover {
      color: #fff;
      text-decoration: underline;
    }
  }
`;

interface Props {
  style?: React.CSSProperties;
}

export default function Footer({ style }: Props) {
  return (
    <Bar style={style}>
      A career exploration tool by{' '}
      <a href="https://integral-ed.com/" target="_blank" rel="noreferrer">
        Integral Ed
      </a>
      {' · '}
      <a href="https://integralelearning.com/" target="_blank" rel="noreferrer">
        Integral eLearning
      </a>
    </Bar>
  );
}
